export class ItemCategoryCache {
  static indexCacheKey() {
    return 'item-categories';
  }

  static showCacheKey() {
    return 'item-category';
  }
}
